import styled from '@emotion/styled';

export const EnterpriseBlockStyled = styled('div')(() => ({
  height: 608,
}));
